 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"action_data_es":"action_data_es","action_data_it":"action_data_it","auth_errors_de_de":"auth_errors_de_de","auth_errors_el_gr":"auth_errors_el_gr","auth_errors_en_gb":"auth_errors_en_gb","auth_errors_es_es":"auth_errors_es_es","auth_errors_it_it":"auth_errors_it_it","auth_errors_ja_jp":"auth_errors_ja_jp","auth_errors_ru_ru":"auth_errors_ru_ru","polyfills":"polyfills","vendors~RegistrationContainer":"vendors~RegistrationContainer","vendors~action_data_com":"vendors~action_data_com","vendors~pre-integrated-quick-deposit":"vendors~pre-integrated-quick-deposit","validators-com-myacc-new-pass":"validators-com-myacc-new-pass","validators-es-myacc-new-pass":"validators-es-myacc-new-pass","validators-it-myacc-new-pass":"validators-it-myacc-new-pass"}[chunkId]||chunkId) + ".chunk." + {"0":"e9f2d0ca37700a9b64a5","1":"73791f5aa5e215e4c23f","2":"4497122d3bba0a521aed","3":"162bf508e293c626edd1","4":"f9c97af79c8e5663f214","5":"fa68564d505256b58d38","6":"c88cf228c5c08ea78ac9","7":"d6c96c5c7fb150764704","8":"e331c9d7aa483f896eae","action_data_es":"e5d790262f4a7aa08338","action_data_it":"33414fa2b12ece899897","auth_errors_de_de":"07be0986017c62d29f54","auth_errors_el_gr":"90e5c0ce18901494e4ce","auth_errors_en_gb":"ad0c88fa71d5e0f147d5","auth_errors_es_es":"831f86fdc6a5d8d2ff61","auth_errors_it_it":"2205b28c8f6b3c3ab615","auth_errors_ja_jp":"1f3f34f84ac8f1c7ac85","auth_errors_ru_ru":"982a39fdcb093da5212d","polyfills":"4258bd1e172a99081461","vendors~RegistrationContainer":"4ad2f487be26aa0de3dc","vendors~action_data_com":"9e5a1328f6ce32e58dff","vendors~pre-integrated-quick-deposit":"557fe1a3aaf4e5ee75cb","validators-com-myacc-new-pass":"b1c6f828eae5407aaee8","validators-es-myacc-new-pass":"c48b82008a74cbdebbe7","validators-it-myacc-new-pass":"d3806ce43a12e4c33d4c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"4":1,"5":1,"6":1,"7":1,"vendors~RegistrationContainer":1,"vendors~pre-integrated-quick-deposit":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"action_data_es":"action_data_es","action_data_it":"action_data_it","auth_errors_de_de":"auth_errors_de_de","auth_errors_el_gr":"auth_errors_el_gr","auth_errors_en_gb":"auth_errors_en_gb","auth_errors_es_es":"auth_errors_es_es","auth_errors_it_it":"auth_errors_it_it","auth_errors_ja_jp":"auth_errors_ja_jp","auth_errors_ru_ru":"auth_errors_ru_ru","polyfills":"polyfills","vendors~RegistrationContainer":"vendors~RegistrationContainer","vendors~action_data_com":"vendors~action_data_com","vendors~pre-integrated-quick-deposit":"vendors~pre-integrated-quick-deposit","validators-com-myacc-new-pass":"validators-com-myacc-new-pass","validators-es-myacc-new-pass":"validators-es-myacc-new-pass","validators-it-myacc-new-pass":"validators-it-myacc-new-pass"}[chunkId]||chunkId) + "-" + {"0":"4a2b70a3317f501e80ff","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"f705c550dcb09b39a2a6","5":"9219a5b5930cb32ef0ec","6":"1494c96f076a9a5da67e","7":"df55085b3cb10fdba93f","8":"31d6cfe0d16ae931b73c","action_data_es":"31d6cfe0d16ae931b73c","action_data_it":"31d6cfe0d16ae931b73c","auth_errors_de_de":"31d6cfe0d16ae931b73c","auth_errors_el_gr":"31d6cfe0d16ae931b73c","auth_errors_en_gb":"31d6cfe0d16ae931b73c","auth_errors_es_es":"31d6cfe0d16ae931b73c","auth_errors_it_it":"31d6cfe0d16ae931b73c","auth_errors_ja_jp":"31d6cfe0d16ae931b73c","auth_errors_ru_ru":"31d6cfe0d16ae931b73c","polyfills":"31d6cfe0d16ae931b73c","vendors~RegistrationContainer":"6a674cffd43c6c00eaf3","vendors~action_data_com":"31d6cfe0d16ae931b73c","vendors~pre-integrated-quick-deposit":"495ebd10c0034f26ee57","validators-com-myacc-new-pass":"31d6cfe0d16ae931b73c","validators-es-myacc-new-pass":"31d6cfe0d16ae931b73c","validators-it-myacc-new-pass":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["wpJsonpHeader"] = window["wpJsonpHeader"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "biqq");
